/** Identifier used for auto-created contacts (not tied to a real user) */
export const SYSTEM_CREATOR_ID = 'system';

/**
 * Default organization ID for tenant scoping.
 * This is the canonical org identifier for OnPoint Generators — the single active tenant.
 * Separate from realmId which scopes QBO financial data to legal entities (OnPoint vs PowerGen).
 */
export const DEFAULT_ORG_ID = 'org_onpoint';
